/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannel } from './NotificationChannel';
import {
    NotificationChannelFromJSON,
    NotificationChannelFromJSONTyped,
    NotificationChannelToJSON,
    NotificationChannelToJSONTyped,
} from './NotificationChannel';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * Serializer for notification groups.
 * @export
 * @interface NotificationGroup
 */
export interface NotificationGroup {
    /**
     * 
     * @type {number}
     * @memberof NotificationGroup
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationGroup
     */
    owner: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationGroup
     */
    name: string;
    /**
     * 
     * @type {Array<NotificationChannel>}
     * @memberof NotificationGroup
     */
    channels: Array<NotificationChannel>;
    /**
     * 
     * @type {Array<User>}
     * @memberof NotificationGroup
     */
    people: Array<User>;
}

/**
 * Check if a given object implements the NotificationGroup interface.
 */
export function instanceOfNotificationGroup(value: object): value is NotificationGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('channels' in value) || value['channels'] === undefined) return false;
    if (!('people' in value) || value['people'] === undefined) return false;
    return true;
}

export function NotificationGroupFromJSON(json: any): NotificationGroup {
    return NotificationGroupFromJSONTyped(json, false);
}

export function NotificationGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'name': json['name'],
        'channels': ((json['channels'] as Array<any>).map(NotificationChannelFromJSON)),
        'people': ((json['people'] as Array<any>).map(UserFromJSON)),
    };
}

export function NotificationGroupToJSON(json: any): NotificationGroup {
    return NotificationGroupToJSONTyped(json, false);
}

export function NotificationGroupToJSONTyped(value?: Omit<NotificationGroup, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'name': value['name'],
        'channels': ((value['channels'] as Array<any>).map(NotificationChannelToJSON)),
        'people': ((value['people'] as Array<any>).map(UserToJSON)),
    };
}

